// src/pages/RegisterPage.js
import React from 'react';
import { Box, Typography, Container, Card, CardContent } from '@mui/material';
import RegisterForm from '../components/Auth/RegisterForm';

function RegisterPage() {
    return (
        <Container component="main" maxWidth="xs" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
            <Card sx={{ width: '100%', p: 3, mt: -8 }}>
                <CardContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2 }}>
                        <Typography component="h1" variant="h5">
                            Registrarse
                        </Typography>
                    </Box>
                    <RegisterForm />
                </CardContent>
            </Card>
        </Container>
    );
}

export default RegisterPage;